import {
  StatisticsItem,
  STATISTICSTYPE,
} from "src/components/atoms/StatisticsItem";
import CheckIcon from "src/assets/icons/check.svg";
import CoinIcon from "src/assets/icons/coin.svg";
import ChartIcon from "src/assets/icons/chart.svg";
import styles from "src/components/molecules/StatisticsBlock/styles.module.css";
import { useIntl } from "react-intl";
import { msg } from "src/i18n/Msg";
import { useGetUserStatistics } from "src/queries/useGetStatistics";

export const StatisticsBlock = () => {
  const intl = useIntl();
  const { data } = useGetUserStatistics();
  const statisticsData = data?.data;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperContent}>
        <StatisticsItem
          img={ChartIcon}
          title={msg(intl, {
            id: "components.molecules.StatisticsBlock.chart",
          })}
          value={
            statisticsData?.trading_volume !== undefined
              ? Number(statisticsData?.trading_volume).toFixed(2)
              : "0"
          }
          type={STATISTICSTYPE.SUCCESS}
          symbol
        />
        <StatisticsItem
          img={CoinIcon}
          title={msg(intl, { id: "components.molecules.StatisticsBlock.coin" })}
          value={
            statisticsData?.profit_loss !== undefined
              ? Number(statisticsData.profit_loss).toFixed(2)
              : "0.00"
          }
          type={
            Number(statisticsData?.profit_loss) <= 0
              ? STATISTICSTYPE.ERROR
              : STATISTICSTYPE.SUCCESS
          }
          symbol
        />
      </div>
      <StatisticsItem
        value={statisticsData?.total_deals ?? "0"}
        img={CheckIcon}
        title={msg(intl, {
          id: "components.molecules.StatisticsBlock.contract",
        })}
      />
    </div>
  );
};
